import React from 'react';
import PropTypes from 'prop-types';
var SvgContextMixin = require('./svgContextMixin');
var SvgFilterFactory = require('./svgFilters');

var SvgChart = React.createClass({
  mixins: [SvgContextMixin],

  statics: {
    id: "Chart",
    dropShadowFilterId: "ChartPolylineDropShadowFilter"
  },

  propTypes: {
    scaleX: PropTypes.number.isRequired,
    scaleY: PropTypes.number.isRequired
  },

  childContextTypes: {
    getPoint: PropTypes.func,
    getLineShadowFilterUrl: PropTypes.func
  },

  getChildContext() {
    var self = this;
    var {box, scaleX, scaleY} = this.props;

    var x0 = box[0],
      y0 = box[1],
      deltaX = box[2] / scaleX,
      deltaY = box[3] / scaleY,
      height = box[3];

    return {
      getPoint(x, y){
        return [
          self.context.relativeX(x0 + x * deltaX),
          self.context.relativeY(y0 + height - y * deltaY)
        ];
      },

      getLineShadowFilterUrl(){
        return self.context.linkTo(SvgChart.dropShadowFilterId);
      }
    }
  },

  componentWillMount(){
    this.context._define(SvgChart.dropShadowFilterId,
      SvgFilterFactory.dropShadow(SvgChart.dropShadowFilterId, 0, 4, 1));
  },

  componentWillUnmount(){
    this.context._undefine(SvgChart.dropShadowFilterId);
  },

  render(){
    return (
      <g id={SvgChart.id}>
        {this.props.children}
      </g>
    );
  }

});


module.exports = SvgChart;
